/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Locked_HintInputs */

const vi_carrier_legacy_locked_hint = /** @type {(inputs: Carrier_Legacy_Locked_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gửi VTP. Muốn sửa: Huỷ vận đơn → sửa địa chỉ → tạo lại.`)
};

/**

* @param {Carrier_Legacy_Locked_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_locked_hint = /** @type {((inputs?: Carrier_Legacy_Locked_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Locked_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_locked_hint(inputs)
});